import { render, staticRenderFns } from "./com.vue?vue&type=template&id=0a41cbdc&scoped=true&"
import script from "./com.vue?vue&type=script&lang=js&"
export * from "./com.vue?vue&type=script&lang=js&"
import style0 from "./com.vue?vue&type=style&index=0&id=0a41cbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a41cbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yangxinyuan/vhall/vhall_questionnaire_service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a41cbdc')) {
      api.createRecord('0a41cbdc', component.options)
    } else {
      api.reload('0a41cbdc', component.options)
    }
    module.hot.accept("./com.vue?vue&type=template&id=0a41cbdc&scoped=true&", function () {
      api.rerender('0a41cbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/com.vue"
export default component.exports